// app
export const ROUTE_SWITCHING = 'ROUTE_SWITCHING'

// account
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const RETRIEVE_ACCOUNT = 'RETRIEVE_ACCOUNT'

// auth
// 检查是否已获得认证,若是则设置状态和http认证头
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION'
// 获得认证:设置状态,保存token,设置http认证头
export const OBTAIN_AUTHENTICATION = 'OBTAIN_AUTHENTICATION'
// 清除认证:清除状态,清除token,清除http认证头
export const CLEAR_AUTHENTICATION = 'CLEAR_AUTHENTICATION'

export const SHOW_PERSONINDEX = 'SHOW_PERSONINDEX'

export const REQUIRE_HEADER = 'REQUIRE_HEADER'



// WEBPACK FOOTER //
// ./src/store/mutation.js